import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoryCarouselComponent } from '~shared/modules/category-carousel/category-carousel.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CategoryBubbleModule } from '~shared/components/category-bubble/category-bubble.module';

@NgModule({
  imports: [CommonModule, CarouselModule, CategoryBubbleModule],
  declarations: [CategoryCarouselComponent],
  exports: [CategoryCarouselComponent],
})
export class CategoryCarouselModule {}
